<template>
  <div>
    <div>
      <!-- <div no-gutters justify="left" align="left">
        <div>
          <h3 class="mb-2" style="display: inline-block; color: #ccc; font-size: 13px; margin: 0 5px">
            <b>{{ $t('comment') }}</b>
          </h3>
          <span
            style="
              display: inline-block;
              vertical-align: middle;
              color: #eeeeee;
              font-size: 10px;
              margin-top: -1px;
              margin-left: 3px;
              border: 1px solid #63737d;
              padding: 1px 5px 0 5px;
              border-radius: 5px;
              height: 18px;
            "
          >
            {{ commentList.length }}
          </span>
        </div>
      </div> -->
      <!-- <div v-if="chkMtPublic && (!currentUser.userId || currentUser.userId === null)" cols="12" class="mt-6 pl-4">
        <div>
          <p style="color: #96a7af; font-size: 13px">Sign in first to leave a comment</p>
        </div>
      </div> -->

      <v-card
        class="commentInputBox"
        :class="{ commentInputBoxClicked: isBoxDrawn }"
        @click="clickInputBox($event)"
        flat
        :ripple="false"
      >
        <!-- <v-card
        v-else
        class="commentInputBox"
        :class="{ commentInputBoxClicked: isBoxDrawn }"
        @click="clickInputBox($event)"
      > -->
        <div class="commentInputBoxInside">
          <div class="textField">
            <v-textarea
              @keydown.enter="onPressEnter($event, comment)"
              @click="clickInputBox"
              id="commentInputBoxId"
              background-color="#2c404a"
              class="textBox"
              rows="1"
              auto-grow
              ref="txta_comment"
              v-model="comment.cmContent"
              placeholder="Leave a comment"
              dense
              hide-details
              solo
              flat
              dark
              style="word-break: keep-all"
            ></v-textarea>
            <div class="PublishBtn">
              <v-btn
                id="postBtn"
                style="background-color: #161d21; color: #aaaaaa; width: 100%; border-radius: 0 0 5px 5px"
                :style="{ display: hasUserEnterValue }"
                :disabled="isPostBtnDisabled"
                class="postBtnClass"
                plain
                height="30"
                :loading="isSaveCommentLoading"
                @click.stop="postComment(comment)"
                elevation="0"
              >
                {{ 'Post' }}
                <span class="kbd-key ml-1">↵ Enter</span>
              </v-btn>
            </div>
          </div>
          <!-- <div class="PublishBtn">
            <v-btn
              id="postBtn"
              style="background-color: #161d21; color: #aaaaaa; border-radius: 10px"
              :style="{ opacity: hasUserInputValue }"
              :disabled="isPostBtnDisabled"
              class="postBtnClass"
              height="36"
              :loading="isSaveCommentLoading"
              @click.stop="postComment(comment)"
              elevation="0"
            >
              {{ 'Post' }}
            </v-btn>
          </div> -->
        </div>
      </v-card>
      <!-- <div class="PublishBtns">
        <v-btn
          id="postBtn"
          style="color: #00ff98; border-radius: 10px"
          :style="{ display: hasUserEnterValue }"
          class="postBtnClass"
          height="36"
          plain
          :loading="isSaveCommentLoading"
          @click.stop="postComment(comment)"
          elevation="0"
        >
          {{ 'Post' }}
        </v-btn>
      </div> -->
    </div>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </div>
</template>

<script>
// import { sendDataWithEnter } from '@/common/common'
import { createComment } from '@/services/commentApi'
import Toast from '@/views/meeting/component/Toast'
import GuestIn from '@/views/modal/GuestIn'
import { debounce } from 'lodash'

export default {
  name: 'DetailCommentInput',
  components: { GuestIn },
  created() {
    this.$root.$refs[`DetailCommentInput-${this.sectionIndex}`] = this
  },
  beforeDestroy() {
    if (this.$refs.txta_comment && this.$refs.txta_comment.$el)
      this.$refs.txta_comment.$el.removeEventListener('keydown', this.deleteBox)
  },
  mounted() {
    // BoxComment 를 직접 그렸을 경우 ESC 버튼으로 해제
    this.deleteBox = function (e) {
      if (e.which === 27) {
        if (this.isBoxDrawn) {
          // this.$store.dispatch('setBoxDrawn', false)
          if (this.boxCommentComponent) this.boxCommentComponent.removeBox()
          if (this.$refs.txta_comment) this.$refs.txta_comment.blur()
        }
      }
    }
    if (this.$refs.txta_comment && this.$refs.txta_comment.$el)
      this.$refs.txta_comment.$el.addEventListener('keydown', this.deleteBox.bind(this))
  },
  data() {
    return {
      debouncedPostComment: null,
      comment: {
        cmContent: '',
        cntComment: '',
      },
      isSaveCommentLoading: false,
      guestInVisible: false,
      guestInActionType: '',
      isPostingComment: false,
      hasUserInputValue: 0,
      isPostBtnDisabled: false,
      hasUserEnterValue: 'none',
    }
  },

  props: ['sectionIndex', 'tabIndex'],

  methods: {
    onPressEnter(e, comment) {
      if (this.isPostingComment) return
      if (e.which === 13 && !e.shiftKey) {
        e.preventDefault()
        this.debouncedPostComment = this.debouncedPostComment || debounce(this.postComment, 500)
        this.debouncedPostComment(comment)
        // this.postComment(comment)
      }
      // sendDataWithEnter(e, args, callbackFnc)
    },

    // postCommentWithEnter(e, comment) {
    //   if (e.key === 'Enter' && !e.shiftKey) {
    //     e.preventDefault()
    //     this.saveReplyFromDC(comment)
    //   }
    // },

    closeGuestIn() {
      this.guestInVisible = false
      if (this.currentUser && !isEmptyObject(this.currentUser)) {
        this.postComment(this.guestInActionType)
      }
      function isEmptyObject(param) {
        return Object.keys(param).length === 0 && param.constructor === Object
      }
    },
    postComment(comment) {
      if (
        this.chkMtPublic &&
        this.chkMtPublic['isPublic'] &&
        (!this.currentUser.userId || this.currentUser.userId === null)
      ) {
        this.guestInActionType = comment
        this.guestInVisible = true
      } else {
        this.saveReply(comment)
      }
      // if (this.detailCommentComponent) saveReply(comment)

      // if (!this.detailCommentComponent) return
      // if (e.key === 'Enter' && !e.shiftKey) {
      //   e.preventDefault()

      //   this.detailCommentComponent.saveReply(comment)
      //   this.emptyCommentInput()
      // }
    },
    clearCommentInput() {
      this.comment.cmContent = ''
    },

    saveCommentLoading(bool) {
      this.isSaveCommentLoading = bool
    },

    clickInputBox() {
      //댓글 인풋창 클릭 이벤트 처리
      if (!this.$store.getters.boxDrawn) {
        this.$store.dispatch('setBoxDrawn', true)
      }
      //boxCommentComponent가 있을때만 발동
      if (this.boxCommentComponent) this.boxCommentComponent.handleCommentInputClickEvent()
      //Remove Clicked Comment + Clicked Comment's box
      //댓글 입력창만 클릭을 해도 바로 영상 멈추게 로직 작성
    },

    async saveReply(comment) {
      //isReply모드가 아니고 박스가 그려졌으면 saveReply 버튼을 누를 때 인풋창 스타일링 제거
      if (comment.cmContent === '') {
        // notify(this, 'Error', 'Content is Empty', 'error')

        const content = {
          component: Toast,
          props: {
            msg: 'Content is Empty',
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }
      // this.isSaveCommentLoading = true
      this.saveCommentLoading(true)
      await this.doSave(comment)

      // 댓글 업로드 후 입력창 Clear 하도록 위치 변경
      this.clearCommentInput()
    },
    async doSave(comment) {
      // let timestamp
      // let stampInfo

      // if (this.mtInfo.mtType === 'topic') {
      //   timestamp = comment.cmContent.match(/\[Clip#\d{2}-\d{2}\s\d{2}:\d{2}]/g)
      // } else {
      //   timestamp = comment.cmContent.match(/\[Clip#\d{2}\s\d{2}:\d{2}]/g)
      // }
      let content = comment.cmContent
      // for (let i in timestamp) {
      //   try {
      //     if (this.mtInfo.mtType === 'topic')
      //       stampInfo = timestamp[i]
      //         .replace('-', ' ')
      //         .replace(/[^0-9.\s\\:]/g, '')
      //         .split(' ')
      //     else stampInfo = timestamp[i].replace(/[^0-9.\s\\:]/g, '').split(' ')

      //     let stId
      //     let clipId

      //     if (this.mtInfo.mtType === 'topic') {
      //       stId = this.totalSectionList[Number(stampInfo[0]) - 1].stId
      //       clipId = this.totalSectionList[Number(stampInfo[0]) - 1].clipList[Number(stampInfo[1] - 1)].clipId
      //       content = content.replaceAll(
      //         'Clip#' + stampInfo[0] + '-' + stampInfo[1],
      //         'stId:' + stId + ' clipId:' + clipId
      //       )
      //     } else {
      //       if (this.mtInfo.mtType === 'chronological') {
      //         clipId = this.totalSectionList[Number(stampInfo[0]) - 1].clipList[0].clipId
      //       } else {
      //         clipId = this.totalSectionList[0].clipList[Number(stampInfo[0]) - 1].clipId
      //       }
      //       content = content.replaceAll('Clip#' + stampInfo[0], 'clipId:' + clipId)
      //     }
      //   } catch (e) {
      //     console.log(e)
      //   }
      // }
      try {
        let time = this.videoControlBarComponent.seekTime / 1000
        let boxData
        if (this.boxCommentComponent) {
          boxData =
            this.boxCommentComponent.getBoxData(time) &&
            this.boxCommentComponent.getBoxData(time) !== undefined &&
            this.boxCommentComponent.getBoxData(time) !== null
              ? this.boxCommentComponent.getBoxData(time)
              : this.boxCommentComponent.getTimeOnlyCommentData()
        }
        await createComment(
          this,
          this.mtInfo.mtId,
          this.currentClip.clipId,
          comment.parentId,
          content,
          comment.cmContent,
          boxData
          // this.$store.getters.boxCommentData && this.$store.getters.boxCommentData !== null
          //   ? this.$store.getters.boxCommentData
          //   : undefined
        )
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'create_comment',
          eventParam: {
            name: 'create_comment',
          },
        })
        // Inbox 채널일 경우 클립 생성 로그 추가
        if (this.selectedCh && this.selectedCh['chCategory'] === 'inbox') {
          this.$store.dispatch('setFirebaseLog', {
            eventName: 'inbox_create_comment',
            eventParam: {
              name: 'inbox_create_comment',
            },
          })
        }

        this.$store.dispatch('setBoxCommentData', null)
        if (this.boxCommentComponent) this.boxCommentComponent.removeBox()
        this.isPostingComment = true

        // this.cancel()
      } catch (e) {
        console.log(e)
      } finally {
        this.detailCommentComponent.getCommentList(false)
        this.clearCommentInput()
        this.saveCommentLoading(false)
        this.isPostingComment = false
      }
    },
  },
  computed: {
    // isGuestVisible() {
    //   return this.guestInVisibleforBox
    // },
    mtInfo() {
      return this.$store.getters.currentMt
    },

    videoControlBarComponent() {
      return this.$root.$refs[`VideoControlBar-${this.sectionIndex}`]
    },

    detailCommentComponent() {
      return this.$root.$refs[`DetailComment-${this.sectionIndex}`]
    },
    boxCommentComponent() {
      return this.$root.$refs[`BoxComment-${this.sectionIndex}`]
    },

    controlbarIconList() {
      return this.$store.getters.controlbarIconList
    },

    commentList() {
      return this.$store.getters.commentList
    },
    isBoxDrawn() {
      return this.$store.getters.boxDrawn
    },
    currentUser() {
      let user = this.$store.getters.userInfo
      return user && user !== null ? user : {}
    },
    currentClip() {
      return this.$store.getters.currentClip
    },
    chkMtPublic() {
      return this.$store.getters.chkMtPublic
    },
    selectedCh() {
      return this.$store.getters.selectedCh
    },
  },
  watch: {
    tabIndex(val) {
      if (val === 2) {
        setTimeout(() => {
          this.$refs.txta_comment.focus()
        }, 20)
      }
    },

    comment: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.cmContent === '') {
          this.hasUserInputValue = 0
          this.isPostBtnDisabled = true
          this.hasUserEnterValue = 'none'
        }
        if (val.cmContent !== '') {
          this.hasUserInputValue = 1
          this.isPostBtnDisabled = false
          this.hasUserEnterValue = 'block'
        }
      },
    },

    isBoxDrawn(val) {
      if (val) {
        this.$refs.txta_comment.focus()
      }
    },
    currentClip() {
      this.comment.cmContent = ''
    },

    guestInVisible(val) {
      this.$store.dispatch('setIsGuestVisible', val)
    },
  },
}
</script>

<style scoped>
.commentInputBox {
  display: flex;
  border: 1px solid transparent;
  background: rgb(71, 94, 105);
  border-radius: 5px;
  width: 100%;
  /* margin-top: 6px; */
  margin-bottom: 9px;
  transition: border 0.3s;
}

@media (max-width: 1263px) {
  /* 반응형 인풋박스 크기 */
  .commentInputBox {
    width: calc(100%);
  }
}

.commentInputBoxClicked {
  /* outline: #ff575f solid 5px; */
  border: 1px solid #ff575f;
  animation: pulse 2s infinite;
  /* 이거를 border 대신에 outline으로 하면 움직이는거 안하고 보더 스타일링 가능 */
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 87, 95, 0.8);
  }
  70% {
    box-shadow: 0 0 0 13px rgba(255, 87, 95, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 87, 95, 0);
  }
}

.commentInputBox .Add {
  outline: none;
}

.commentInputBox .textField {
  width: 100%;
}

.textBox {
  /* background-color: #30444e; */
  resize: none;
  width: 100%;
  /* padding-left: 10px;
  padding-right: 10px; */
  color: #fff;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 5px;
  font-size: 14px;
}

.textBox >>> .v-input__control {
  min-height: 30px !important;
}

.textBox >>> textarea::placeholder {
  font-size: 12px;
  font-weight: 300;
  opacity: 0.5;
  letter-spacing: 0.2px;
}

.textBox >>> textarea {
  line-height: 25px;
}

.textarea-col >>> .v-input {
  font-size: 14px;
}

.textarea-col >>> i {
  font-size: 17px;
  color: #999;
}

.commentInputBox .PublishBtn {
  display: flex;
  /* justify-content: flex-end; */
  justify-content: center;
  align-items: end;
  background-color: #475e69;
  /* border-top: 1px solid #30444e; */
  /* border-radius: 0 10px 10px 0; */
}

.PublishBtns {
  width: 100%;
}
.postBtnClass >>> span {
  font-size: 13px;
  font-weight: 500;
}

.commentInputBoxInside {
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  width: 100%;
}

.crown {
  color: #ffc542;
  font-size: 15px;
  position: relative;
  transform: translate(0px, -45px);
}
.v-avatar {
  border: 2px solid #30444e !important;
}
.logo label {
  display: inline;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}

.logo label:hover {
  border-bottom: 1px solid #666;
}

.logo input {
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  text-indent: -9999px;
}

.logo img {
  display: block;
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: cover;
}

.v-text-field--outlined >>> fieldset {
  border-color: transparent;
}

.textarea-col >>> .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-left: 5px;
}

.textarea-col >>> .v-text-field__slot textarea {
  color: #ffffff !important;
  line-height: 25px !important;
}

.save_btn {
  font-size: 12px;
}

.cancel_btn {
  background-color: transparent !important;
  font-size: 11px;
}

.comment_btn {
  background-color: transparent !important;
  font-size: 12px;
  padding-left: 0;
  padding-right: 0;
  width: 50px !important;
}

.comment_btn_col >>> .v-btn:not(.v-btn--round).v-size--default {
  min-width: 50px !important;
}

.a-timestamp {
  font-size: 14px;
  display: inline;
  padding-left: 8px;
  padding-right: 8px;
}
.v-app-bar__nav-icon >>> .v-btn__content {
  text-align: start;
}
.container-comment {
  display: block;
  padding: 0 15px 0 0;
  height: 100%;
}
.chronological-comment {
  /* padding-right: 20px; */
  /* max-height: calc(100vh - 420px); */
  overflow-y: scroll;
  overflow-x: hidden;
}

@media (max-width: 1263px) {
  .chronological-comment {
    max-width: 100%;
    max-height: 100%;
  }
  .container-comment {
    margin-bottom: 100px;
  }
}
.kbd-key {
  display: inline-block;
  box-sizing: border-box;
  background-color: #ccc;
  margin: 2px;
  border-radius: 4px;
  border: solid #121c20;
  border-width: 1px 1px 2px;
  padding: 1px 2px;
  color: #161d21;
  font-size: 12px !important;
  font-weight: 700 !important;
  min-width: 24px;
  text-align: center;
  letter-spacing: -1px;
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.1);
}
</style>
